import React from "react";

import "./FooterOverlay.css";

const FooterOverlay = () => (
  <div>
    <div className="app__footerOverlay-black" />
    <div className="app__footerOverlay-img app__bg" />
    FooterOverlay
  </div>
);

export default FooterOverlay;
